<section class="card-atividades" [class.card-lateral]="!plano()">
    <p-table [value]="atividades()" styleClass="tabela-lateral tabela-atividades" [tableStyle]="{ 'min-width': '100%' }">
        <ng-template pTemplate="header">
            <tr>
                <th class="coluna-numero">Número</th>
                <th>Atividades</th>
                <th class="coluna-acoes text-center">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-atividade>
            <tr [class.linha-atividade-ativa]="atividadeSelecionada()?.idTarefa === atividade.idTarefa" (click)="selecionar.emit(atividade)">
                <td>{{ atividade.numero }}</td>
                <td>{{ atividade.descricao }}</td>
                <td class="coluna-acoes text-center">
                    <button
                        type="button"
                        pButton
                        icon="pi pi-pencil"
                        severity="secondary"
                        [text]="true"
                        [rounded]="true"
                        size="small"
                        [disabled]="!permiteAlteracao()"
                        [appCan]="roleAtividadesEditar"
                        (click)="$event.stopPropagation(); editar.emit(atividade)"
                        title="Editar atividade"
                        aria-label="Editar atividade"
                    ></button>
                    <button
                        type="button"
                        pButton
                        icon="pi pi-trash"
                        severity="danger"
                        [text]="true"
                        [rounded]="true"
                        size="small"
                        [disabled]="!permiteAlteracao()"
                        [appCan]="roleAtividadesExcluir"
                        (click)="$event.stopPropagation(); excluir.emit(atividade)"
                        title="Excluir atividade"
                        aria-label="Excluir atividade"
                    ></button>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <label class="atividade-resolvida">
        <input type="checkbox" [checked]="atividadeResolvida()" [disabled]="!permiteAlteracao() || !atividadeSelecionada()" [appCan]="roleAtividadesEditar" (change)="aoAlternarResolvida($event)" />
        <span>Atividade Resolvida</span>
    </label>
</section>
